export enum GenericServiceErrorCode {
  INTREGEMISSIONSINSTAVUKETS1007 = 'INTREGEMISSIONSINSTAVUKETS1007',
  INTREGACCOUNTCREATEUKETS1000 = 'INTREGACCOUNTCREATEUKETS1000',
  INTREGACCOUNTCREATEUKETS1001 = 'INTREGACCOUNTCREATEUKETS1001',
}
